module.exports = "<div class=\"order-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-upload-section ng-model=\"vm.order\" type=\"order\"></blnd-upload-section>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/templates/detail.files.html
// module id = 638
// module chunks = 0